export const PAYMENT_METHOD_INVOICE = "Invoice";
export const PAYMENT_METHOD_DIRECT_DEBIT = "Direct Debit";
export const PAYMENT_METHODS = [PAYMENT_METHOD_INVOICE, PAYMENT_METHOD_DIRECT_DEBIT];
export const DEFAULT_CREDIT_LIMIT = 750;

export const BANKACCOUNT_TYPE_NL = "NLI";
export const BANKACCOUNT_TYPE_BE = "BEI";
export const BANKACCOUNT_TYPE_DE = "DEI";
export const BANKACCOUNT_TYPE_FR = "FRI";
